// TODO: Change name to more descriptive one

import React from 'react';
import { Icon } from '../../../../../patterns/00-atoms/icon/icon.tsx';
import { Toggletip } from '../../../../../patterns/00-atoms/toggletip/toggletip.tsx';

export const RestaurantMembershipType = {
  PREMIUM: 'PREMIUM',
  CLAIM: 'CLAIM',
  CLOSED: 'CLOSED'
} as const;

export type RestaurantMemebershipProps = {
  membershipType: string;
};

export const RestaurantMemebership: React.FunctionComponent<RestaurantMemebershipProps> = props => {
  const { membershipType } = props;

  switch (membershipType) {
    case RestaurantMembershipType.PREMIUM:
      return (
        <Toggletip
          button={buttonsProps => {
            return (
              <button {...buttonsProps} className="ml-1">
                <Icon
                  name="premium"
                  className="text-sk-grey-0 bg-sk-red-500 cursor-pointer rounded-full p-1 text-lg"
                />
              </button>
            );
          }}
          content={<div className="text-sm">Premium</div>}
        />
      );
    case RestaurantMembershipType.CLAIM:
      return (
        <Toggletip
          button={buttonsProps => {
            return (
              <button {...buttonsProps} className="ml-1">
                <Icon name="verified" className="cursor-pointer text-2xl" />
              </button>
            );
          }}
          content={
            <div className="text-sm">Dieses Restaurant wird vom Gastronom selbst verwaltet.</div>
          }
        />
      );
    default:
      return null;
  }
};
